import { $, $$ } from '@utils/dom';
import { on, off } from "@utils/listener";
import ResizeOrientation from "@utils/resize";

import SwiperCore, { Swiper, Pagination } from "swiper";
import Viewport from "@utils/viewport";
import windmill from "@core/windmill";

import ProductForm from "@modules/product-form";
import ProductWishlist from "@modules/product-wishlist";
// import Sharing from "@modules/sharing";
// import AnimatedAccordions from "@modules/animated-accordions";

// configure Swiper to use modules
SwiperCore.use([Pagination]);


const SWIPER_OPTIONS = {
  centeredSlides: false,
  freeMode: false,
  slidesPerView: 1,
  pagination: {
    el: ".product-single__mediasPagination",
    clickable: true,
  }
};

class ProductSingle {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;

    this._onResize = this._onResize.bind(this);
    this._onZoomBtnClick = this._onZoomBtnClick.bind(this);
    this._onMediaClick = this._onMediaClick.bind(this);
    this._onProductViewerClose = this._onProductViewerClose.bind(this);
    this._onProductViewerClosed = this._onProductViewerClosed.bind(this);

    this._redirect = this._redirect.bind(this);
    this._render = this._render.bind(this);
  }

  init() {
    this.slider = $('.product-single__slider', this.el);
    this.medias = [ ...$$('.product-single__img', this.el) ];
    this.zoomBtn = $('.product-single__zoomBtn', this.el);

    this.productForm = new ProductForm($('.product-form', this.el), this.emitter);
    this.productWishlist = new ProductWishlist($('.product-wishlist', this.el), this.emitter);
    // this.sharing = new Sharing($('.product-single__sharing', this.el), this.emitter);

    // if ($('.product-single__accordions', this.el)) {
    //   this.accordions = new AnimatedAccordions($('.product-single__accordions', this.el), this.emitter);
    // }

    this._bindEvents();
    this._createSlider();
  }
  destroy() {
    this._clear();

    this.el = null;
    this.emitter = null;

    this._onResize = null;
    this._onZoomBtnClick = null;
    this._onMediaClick = null;
    this._onProductViewerClose = null;
    this._onProductViewerClosed = null;

    this._redirect = null;
    this._render = null;
  }

  _clear(){

    this._unbindEvents();

    if (this.productForm) this.productForm.destroy();
    if (this.productWishlist) this.productWishlist.destroy();
    // if (this.sharing) this.sharing.destroy();
    // if (this.accordions) this.accordions.destroy();

    if (this.swiper) this.swiper.destroy();

    this.slider = null;
    this.medias = null;
    this.zoomBtn = null;
    this.swiper = null;
    this.productForm = null;
    this.productWishlist = null;
    this.sharing = null;
    this.accordions = null;
  }

  _bindEvents() {
    // ResizeOrientation.add(this._onResize);

    if( this.zoomBtn ) on(this.zoomBtn, 'click', this._onZoomBtnClick);
    if( this.medias ) on(this.medias, 'click', this._onMediaClick);
    if ( this.emitter ) this.emitter.on('ProductForm.variantChange', this._redirect);
  }
  _unbindEvents() {
    // ResizeOrientation.remove(this._onResize);

    if( this.zoomBtn ) off(this.zoomBtn, 'click', this._onZoomBtnClick);
    if( this.medias ) off(this.medias, 'click', this._onMediaClick);
    if( this.emitter ) {
      this.emitter.off('ProductViewer.close', this._onProductViewerClose);
      this.emitter.off('ProductViewer.closed', this._onProductViewerClosed);
      this.emitter.off('ProductForm.variantChange', this._redirect);
    }
  }
  _openGallery(index) {
    const media = this.medias[index];

    this.emitter.on('ProductViewer.close', this._onProductViewerClose);
    this.emitter.on('ProductViewer.closed', this._onProductViewerClosed);
    this.emitter.emit('SiteScroll.stop', true);
    this.emitter.emit('ProductViewer.open', this.medias, index, [media], this.zoomBtn, event);

    // hide media & zoom-in button
    media.style.visibility = 'hidden';
    this.zoomBtn.style.visibility = 'hidden';
  }

  _onResize(){
    if(Viewport.width < 768) {
      this._createSlider();
    } else {
      this._deleteSlider();
    }
  }

  _onZoomBtnClick(event) {
    if( event ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    this._openGallery( this.swiper ? this.swiper.activeIndex : 0);
  }
  _onMediaClick(event) {
    if( event ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    const index = this.medias.indexOf(event.currentTarget);
    this._openGallery(index);
  }
  _onProductViewerClose(index) {
    // update medias visibility
    this.medias.forEach((media, i) => {
      if( i === index ) media.style.visibility = 'hidden';
      else media.style.removeProperty('visibility');
    });
  }
  _onProductViewerClosed() {
    // show medias & zoom-in button
    this.medias.forEach(media => media.style.removeProperty('visibility'));
    this.zoomBtn.style.removeProperty('visibility');

    this.emitter.off('ProductViewer.close', this._onProductViewerClose);
    this.emitter.off('ProductViewer.closed', this._onProductViewerClosed);

    this.emitter.emit('SiteScroll.start');
  }

  _createSlider(){
    if (!this.swiper && this.slider) {
      this.swiper = new Swiper(this.slider, { ...SWIPER_OPTIONS, ...{ 
      navigation: {
        prevEl: $('.product-single__prev', this.el),
        nextEl: $('.product-single__next', this.el),
      },
      pagination: {
        el: $('.product-single__pagination', this.el),
        clickable: true,
      }

     } });
    }
  }
  _deleteSlider(){
    if(!this.swiper) return;

    this.swiper.destroy();
    this.swiper = null;
  }

  _redirect(variant_id){

    this.el.classList.add('--updating');

    let url = window.location.pathname;
    url += '?variant=';
    url += variant_id;

    fetch(url)
    .then((response) => {
      if(response.ok) {
        return response.text()
      }
      return Promise.reject(response);
    })
    .then(response => {
      this._render(response);
      windmill.replace(url);
      this.el.classList.remove('--updating');
    })
    .catch(response => {
      this.el.classList.remove('--updating');
    });
  }

  _render(html){

    const newDOM = new DOMParser().parseFromString(html, "text/html");
    const newEl = $(`#${this.el.id}`, newDOM);

    this._clear();

    this.el.innerHTML = newEl.innerHTML;

    this.emitter.emit('SiteScroll.update');
    this.emitter.emit('ProductViewer.refresh');

    this.init();
  }

}


export default ProductSingle;
